import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _defineProperty from "/var/www/kanoon-stage/frontend/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useEffect, useState } from 'react';
import styles from "./dropdown.module.css";
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import LearnLessonDone from "../../modals/LearnLessonDone";
import DropDownBooks from "../dropDownBooks";
import useTranslation from "next-translate/useTranslation";
import ButtonLoading from "../../buttonLoading";

var DropdownLesson = function DropdownLesson(_ref) {
  var classes = _ref.classes,
      defaultSelected = _ref.defaultSelected,
      data = _ref.data,
      setValidated = _ref.setValidated,
      setSelectedLesson = _ref.setSelectedLesson,
      selectedLesson = _ref.selectedLesson,
      setError = _ref.setError,
      setShow = _ref.setShow,
      gameFirstTimeUser = _ref.gameFirstTimeUser,
      setGameFirstTimeUser = _ref.setGameFirstTimeUser,
      mode = _ref.mode,
      setLearnType = _ref.setLearnType,
      getLessonsLoading = _ref.getLessonsLoading;

  var _useState = useState(false),
      dropdownOpen = _useState[0],
      setDropdownOpen = _useState[1];

  var _useState2 = useState(false),
      showLearnLessonDone = _useState2[0],
      setShowLearnLessonDone = _useState2[1];

  var toggle2 = function toggle2() {
    return setShowLearnLessonDone(function (prevState) {
      return !prevState;
    });
  };

  var _useState3 = useState(null),
      name = _useState3[0],
      setName = _useState3[1];

  var _useState4 = useState(''),
      firstTimeUser = _useState4[0],
      setFirstTimeUser = _useState4[1];

  var _useTranslation = useTranslation(),
      t = _useTranslation.t,
      lang = _useTranslation.lang;

  var isRTL = lang === 'farsi';
  useEffect(function () {
    setFirstTimeUser(gameFirstTimeUser);
  }, [gameFirstTimeUser]);

  var toggle = function toggle() {
    var Username = localStorage.getItem('Username');

    if (Username) {
      setDropdownOpen(function (prevState) {
        return !prevState;
      });
    } else {
      setError(["login", false]);
      setShow(true);
    }
  };

  useEffect(function () {
    setSelectedLesson({
      code: null,
      name: isRTL ? defaultSelected.fa : defaultSelected.en
    });
  }, [isRTL]);

  var handleSelect = function handleSelect(selectedItem) {
    if (selectedItem.item.wordcount !== 0) {
      setSelectedLesson({
        code: selectedItem.item.GroupCodeId,
        name: isRTL ? selectedItem.item.PersianTitle : selectedItem.item.LessonName,
        id: selectedItem.item.LessonId
      });
      setValidated(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          lesson: true
        });
      });

      if (mode === 'test') {
        var gameFirstTimeUserConst = localStorage.getItem('gameFirstTimeUser');

        if (gameFirstTimeUserConst !== '4') {
          localStorage.setItem('gameFirstTimeUser', 3);
          setGameFirstTimeUser(3);
        }
      } else if (mode === 'learn') {
        var learnFirstTimeUserConst = localStorage.getItem('learnFirstTimeUser');

        if (learnFirstTimeUserConst !== '4') {
          localStorage.setItem('learnFirstTimeUser', 3);
          setGameFirstTimeUser(3);
        }
      }
    } else {
      setName(selectedItem);
      toggle2();
    }
  };

  console.log("getLessonsLoading", getLessonsLoading);
  return /*#__PURE__*/_jsxs("div", {
    className: styles.wrapper,
    children: [firstTimeUser == 2 && /*#__PURE__*/_jsx("div", {
      className: "".concat(styles.toolTip, " ").concat(isRTL ? '' : styles.toolTipEn),
      children: /*#__PURE__*/_jsx("p", {
        className: "".concat(styles.toolTipText, " ").concat(isRTL ? '' : styles.toolTipTextEn),
        children: t('start:Choose the lesson you want to play')
      })
    }), /*#__PURE__*/_jsx(LearnLessonDone, {
      show: showLearnLessonDone,
      toggle: toggle2,
      name: name
    }), /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsxs(Dropdown, {
        className: "".concat(styles.menuItem, " ").concat(classes.bg),
        isOpen: dropdownOpen,
        toggle: toggle,
        children: [/*#__PURE__*/_jsx(DropdownToggle, {
          caret: true,
          children: getLessonsLoading ? /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(ButtonLoading, {}), /*#__PURE__*/_jsx("span", {
              children: "loading"
            })]
          }) : /*#__PURE__*/_jsx(_Fragment, {
            children: selectedLesson.name
          })
        }), /*#__PURE__*/_jsx(DropdownMenu, {
          children: data && data.length > 0 ? data.map(function (item, index) {
            return /*#__PURE__*/_jsxs(DropdownItem, {
              className: item.wordcount === 0 ? styles.done : styles.lessonWrapper,
              onClick: function onClick() {
                return handleSelect({
                  item: item,
                  id: index + 1
                });
              },
              children: [/*#__PURE__*/_jsx("p", {
                className: styles.lessonName,
                children: isRTL ? item.PersianTitle : item.LessonName
              }), mode === "test" ? /*#__PURE__*/_jsx("p", {
                className: styles.allWords,
                style: {
                  marginLeft: isRTL ? '3px' : 'auto',
                  marginRight: isRTL ? 'auto' : '3px'
                },
                children: item.AllWords
              }) : /*#__PURE__*/_jsxs(_Fragment, {
                children: [/*#__PURE__*/_jsx("p", {
                  className: styles.allWordsLearn,
                  style: {
                    marginLeft: isRTL ? '3px' : 'auto',
                    marginRight: isRTL ? 'auto' : '3px'
                  },
                  children: item.AllWords
                }), /*#__PURE__*/_jsx("p", {
                  className: styles.trueAnswers // onClick={()=>setLearnType(1)}
                  ,
                  children: item.TrueAnswers
                }), /*#__PURE__*/_jsx("p", {
                  className: styles.wrongAnswers // onClick={()=>setLearnType(2)}
                  ,
                  children: item.WrongAnswers
                })]
              })]
            }, index);
          }) : /*#__PURE__*/_jsx(DropdownItem, {
            children: t('start:Choose a book')
          })
        })]
      })
    }), /*#__PURE__*/_jsx("div", {
      className: classes.arrow
    })]
  });
};

export default DropdownLesson;